declare var swal: any;
import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../../services/actor.service';
//import { DBOperation } from '../../../../../enums/enum';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../../services/hcp.service';
import { ActorEducationInfoRequest, ActorEducationInfoController } from '../../../../models/profileinfo/profileinfo.model';
//import { NgbEducationInfoModal } from '../../educationinfo/modals/educationinfo.modal';
//import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
//import * as moment from 'moment';
import { CustomDateTimeService } from '../../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import {
  ShiftAllocPatternRequest, CareUnitInfoRequest, ParentCareUnitsInfoController, CareUnitByParentCodeInfoController, ShiftTypeInfoRequest,
  ShiftTypeInfoController, StaffTypeInfoRequest, StaffTypeInfoController, MasterH2RContractAddRequest, MasterH2RContractGetRequest, MasterH2RContractController
} from '../../../../models/hcare/hcare.model';
import { HcareService } from '../../../../services/hcare.service';
import { FaciliesInfoByTypeController, FacilitiesInfoByTypeRequest, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, ServiceConsultantMapRequest, ServiceConsultantMapController } from '../../../../models/actor/actor';
//import { NgbAddServiceModal } from '../view-general/modal/addservice.modal';
//import { NgbAddCategoryModal } from '../modals/addcategory.modal';
//import { NgbEditCategoryModal } from '../modals/editcategory.modal';
//import { NgbEditServiceModal } from '../view-general/modal/editservice.modal';
//import { NgbEditBranchModal } from '../view-branch/modal/editbranch.modal';
//import { NgbEditConsultantModal } from '../view-consultant/modal/editconsultant.modal';

import { NgbEditObservationModal } from '../modals/editobservation.modal';
import { NgbTestRangeModal } from './modals/testrange.modal';
import { NgbEditTestinfoModal } from '../modals/edittestinfo.modal';
import { NgbEditSpecimenModal } from '../modals/editspecimen.modal';
import { NgbAddNotesModal } from '../modals/addnotes.modal';






import { GetTestInformationDetailsRequest, TestInformationData, SpecimenData, ObservationData, SaveTestInformationRequest, SaveSpecimenInfoRequest, SaveObservationsInfoRequest, SaveNotesInfoRequest } from '../../../../models/lab/testinfo.model';

@Component({
  selector: 'testinformation',
  templateUrl: './testinformation.component.html',
  styleUrls: ['./testinformation.component.scss']
})

export class TestinformationComponent implements OnInit, OnChanges{
  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() ServiceCode: number;
  
  @Input() ServiceName: string;
  @Input() DepartmentName: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;
  searchTitle: string;

  public testInfo: TestInformationData;
  public specimen: SpecimenData;
  public observationsList: ObservationData[] = [];
  public masterObservationsList: any[] = [];
  public notesText: string = 'Add Notes Here...';

  CurrentActorEducationInfoRequest: ActorEducationInfoRequest;
  CurrentActorEducationInfoController: ActorEducationInfoController[];

  //
  CurrentActorEditEducationInfoRequest: ActorEducationInfoRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true; 
  @Input()
  public ShowService: boolean = true;
  public SelectedService: boolean = true;
  public RequestedPositions: number = 100;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();


  CurrentServiceDetailsByCodeController: ServiceDetailsByCodeController[];
  CurrentServiceDetailsByCodeRequest: ServiceDetailsByCodeRequest ;

  BranchMapData: ServiceBranchMapByServiceCodeController[];
  BranchMapRequest: ServiceBranchMapByServiceCodeRequest;


  ConsultantMapData: ServiceConsultantMapController[];
  ConsultantMapRequest: ServiceConsultantMapRequest;

  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  AddSpecialty: string;

  //AddStaffTypeCode: number;

  //AddShiftTypeCode: number;

  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
      if (property === 'ServiceCode' || property === 'ServiceName' || property === 'DepartmentName') {
        this.loadTestInformationDetails();
      }
    }
  }

  loadTestInformationDetails() {
    this.StartRefreshing();
    const req = new GetTestInformationDetailsRequest();
    req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    req.ServiceCode = this.ServiceCode;
    req.ServiceName = this.ServiceName;
    req.DepartmentName = this.DepartmentName;

    this.actorservice.GetTestInformationDetails(req).subscribe(
      (result) => {
        this.stopRefreshing();
        if (result && !result.hasError && result.Result) {
          const res = result.Result;
          if (res.TestInfo || res.testInfo) {
            this.testInfo = res.TestInfo || res.testInfo;
          }
          if (res.Specimen || res.specimen) {
            this.specimen = res.Specimen || res.specimen;
          }
          if (res.Observations || res.observations) {
            this.observationsList = res.Observations || res.observations;
          }
          if (res.MasterObservations || res.masterObservations) {
            this.masterObservationsList = res.MasterObservations || res.masterObservations;
          }
          if (res.Notes || res.notes) {
            this.notesText = res.Notes || res.notes;
          }
        }
      },
      (error) => {
        this.stopRefreshing();
      }
    );
  }

  ngOnInit() {
    this.loadTestInformationDetails();
    this.LoadMasterData();
  }

  LoadRegistries() {
    this.StartRefreshing();


    this.CurrentServiceDetailsByCodeController = new Array<ServiceDetailsByCodeController>();
    
    this.CurrentServiceDetailsByCodeRequest = new ServiceDetailsByCodeRequest();
    this.CurrentServiceDetailsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.BranchMapRequest = new ServiceBranchMapByServiceCodeRequest();
    this.BranchMapRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ConsultantMapRequest = new ServiceConsultantMapRequest();
    this.ConsultantMapRequest .SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.GetServiceDetailsByCodeController();
    this.GetBranchMap();
    this.GetConsultantMap();


  }
  SelectedRegistry: FaciliesInfoByTypeController;
  ViewRateContracts(l: any) {

    //alert(l.DisplayName);

    this.SelectedRegistry = l;
    this.LoadContracts();

  }
  GetConsultantMap() {
    this.StartRefreshing();
    this.ConsultantMapRequest.ServiceCode = this.ServiceCode;
    this.ConsultantMapRequest.ProviderCode = -1;

    this.actorservice.GetServiceConsultantMapControllerController(this.ConsultantMapRequest)
      .subscribe((result) => {
        this.ApiResData = result;
   
        if (!this.ApiResData.hasError) {

          this.ConsultantMapData = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );




  }
  GetBranchMap() {
    this.StartRefreshing();
    this.BranchMapRequest.ServiceCode = this.ServiceCode;

    this.actorservice.GetServiceBranchMapByServiceCodeController(this.BranchMapRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.BranchMapData = this.ApiResData.Result;
        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );


  }
  //SelectedService: ServiceDetailsByCodeController;
  //GetServiceDetailsByCodeController() {
  //  //alert("calling GetServiceDetailsByCodeController")
  //  this.StartRefreshing();
  //  this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //  this.actorservice.GetServiceDetailsByCodeController(this.CurrentServiceDetailsByCodeRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentServiceDetailsByCodeController = this.ApiResData.Result;
  //        this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}
  constructor(private router: Router,
    private hcareservice: HcareService,
    private actorservice: ActorService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, 
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  // ngOnInit is implemented above
  CurrentShiftTypeInfoRequest: ShiftTypeInfoRequest;
  CurrentShiftTypeInfoController: ShiftTypeInfoController[];

  CurrentStaffTypeInfoRequest: StaffTypeInfoRequest;
  CurrentStaffTypeInfoController: StaffTypeInfoController[];

  LoadMasterData(){

    this.LoadRegistries(); 
 


  }
  MasterH2RContractGetRequest: MasterH2RContractGetRequest;
  MasterH2RContractController: MasterH2RContractController[];
  public LoadContracts() {


    this.MasterH2RContractGetRequest = new MasterH2RContractGetRequest();
    this.MasterH2RContractGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.MasterH2RContractGetRequest.HospitalActorCode = AppData.Instance().UserLoginDetails.FacilityActorCode;
    this.MasterH2RContractGetRequest.RegistryActorCode = this.SelectedRegistry.FacilityActorCode;
    this.MasterH2RContractController = new Array<MasterH2RContractController>();

    this.GetMasterH2RContractController();



  }
  GetMasterH2RContractController() {
    this.StartRefreshing();
    this.hcareservice.GetMasterH2RContractController(this.MasterH2RContractGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.MasterH2RContractController = this.ApiResData.Result;


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  //Editgeneral() {
  //  //alert(this.Addgeneral);
  //  const modalRef = this.modalService.open(NgbEditServiceModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  
  observationmodal(obs?: any) {
    const modalRef = this.modalService.open(NgbEditObservationModal, { centered: true, size: "lg" });
    modalRef.componentInstance.ObservationsList = this.observationsList;
    modalRef.componentInstance.MasterObservations = this.masterObservationsList;
    if (this.testInfo) {
      modalRef.componentInstance.TestCode = this.testInfo.TestCode || this.ServiceCode;
      modalRef.componentInstance.TestName = this.testInfo.Name || this.ServiceName;
    }
    if (obs) {
      modalRef.componentInstance.ObservationData = obs;
    }
    modalRef.result.then(() => { this.loadTestInformationDetails(); }, () => {});
  }
  rangemodal(obs?: any) {
    const modalRef = this.modalService.open(NgbTestRangeModal, { centered: true });
    if (obs) {
      modalRef.componentInstance.ObservationData = obs;
    }
    modalRef.result.then(() => { this.loadTestInformationDetails(); }, () => {});
  }
  edittestmodal() {
    const modalRef = this.modalService.open(NgbEditTestinfoModal, { centered: true });
    if (this.testInfo) {
      modalRef.componentInstance.TestInfo = this.testInfo;
    }
    modalRef.result.then(() => { this.loadTestInformationDetails(); }, () => {});
  } 
  editspecimenmodal() {
    const modalRef = this.modalService.open(NgbEditSpecimenModal, { centered: true });
    if (this.specimen) {
      modalRef.componentInstance.SpecimenData = this.specimen;
    }
    modalRef.result.then(() => { this.loadTestInformationDetails(); }, () => {});
  }
  addnotesmodal() {
    const modalRef = this.modalService.open(NgbAddNotesModal, { centered: true });
    modalRef.componentInstance.NotesText = this.notesText;
    modalRef.result.then((newNotes) => {
      if (newNotes) { this.notesText = newNotes; }
      this.loadTestInformationDetails();
    }, () => {});
  }
  public AddShiftTypeCode: number;

  GetShiftTypeInfoController() {
    this.StartRefreshing();
    this.hcareservice.GetShiftTypeInfoController(this.CurrentShiftTypeInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentShiftTypeInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  viewservice() {
   this.ShowService = true;
  }
  IsSelected(){

  }
  //Addgeneral() {
    
  //  const modalRef = this.modalService.open(NgbAddServiceModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  public AddStaffTypeCode: number;
  GetStaffTypeInfoController() {
    this.StartRefreshing();
    this.hcareservice.GetStaffTypeInfoController(this.CurrentStaffTypeInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentStaffTypeInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    //this.CurrentActorEducationInfoRequest = null;
    //this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    //this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 1;
    //this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
   

  }
  clearData() {
   
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  public onInputValidFrom(value: Date): void {

    console.log('value-->' + value);

    this.CurrentActorEditEducationInfoRequest.StartFrom = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditEducationInfoRequest.CompletedAt = value;
  }

  GetActorEducationInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorEducationInfoController(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorEducationInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit_() {
   // alert("On Submit");
    if (this.ShowList) {

      return;
    }
    else {
    //  alert("not showing list, proceed to savve...");
    }
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 1;
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEducationInfoRequest.StartFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEducationInfoRequest.StartFrom);
    //  this.CurrentActorEducationInfoRequest.CompletedAt = this.customdatetimeservice.converToLocalTime(this.CurrentActorEducationInfoRequest.CompletedAt);
    //  //console.log('ssssssssssssssssssssssssssssssss->'+this.CurrentActorEducationInfoRequest.StartFrom);
    //  //console.log('asdddddddddddddddddddd--->' + a);

    //  //this.CurrentActorEducationInfoRequest.StartFrom = a;

    //  //console.log('asdddddddddddddddddddd--->' + this.CurrentActorEducationInfoRequest.StartFrom);

    //  //if (this.CurrentActorEducationInfoRequest.StartFrom != null && this.CurrentActorEducationInfoRequest.StartFrom.getFullYear() > 1990) {
    //  //  this.CurrentActorEducationInfoRequest.StartFrom.setMinutes(this.CurrentActorEducationInfoRequest.StartFrom.getMinutes() + -(this.CurrentActorEducationInfoRequest.StartFrom.getTimezoneOffset()))


    //  //}
    //  //if (this.CurrentActorEducationInfoRequest.CompletedAt != null && this.CurrentActorEducationInfoRequest.CompletedAt.getFullYear() > 1990) {

    //  //  this.CurrentActorEducationInfoRequest.CompletedAt.setMinutes(this.CurrentActorEducationInfoRequest.CompletedAt.getMinutes() + -(this.CurrentActorEducationInfoRequest.CompletedAt.getTimezoneOffset()))

    //  //}

    //}

    if (this.ValidFrom != null) {



      this.CurrentActorEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEducationInfoRequest.CompletedAt = new Date(this.parserFormatter.format(this.ValidTo));;
    }
   
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEducationInfoController();
           // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }
  BackToServices() {
    //this.router.navigate(['testnurse/service']);
    //this.router.navigate(['testnurse/service']);
   
   
  }
  edit_(EditCurrentActorEducationInfoController: ActorEducationInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditEducationInfoRequest.EducationCode = EditCurrentActorEducationInfoController.EducationCode;
    this.CurrentActorEditEducationInfoRequest.ActorCode = EditCurrentActorEducationInfoController.ActorCode;
    this.CurrentActorEditEducationInfoRequest.InstituteName = EditCurrentActorEducationInfoController.InstituteName;
    this.CurrentActorEditEducationInfoRequest.InstituteType = EditCurrentActorEducationInfoController.InstituteType;
    this.CurrentActorEditEducationInfoRequest.Location = EditCurrentActorEducationInfoController.Location;
    this.CurrentActorEditEducationInfoRequest.CourseStudy = EditCurrentActorEducationInfoController.CourseStudy;
    this.CurrentActorEditEducationInfoRequest.StartFrom = EditCurrentActorEducationInfoController.StartFrom;
    this.CurrentActorEditEducationInfoRequest.CompletedAt = EditCurrentActorEducationInfoController.CompletedAt;


    if (this.CurrentActorEditEducationInfoRequest.StartFrom != null) {
      var SValidFrom = new Date(this.CurrentActorEditEducationInfoRequest.StartFrom);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditEducationInfoRequest.CompletedAt != null) {
      var SValidTo = new Date(this.CurrentActorEditEducationInfoRequest.CompletedAt);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }



    this.CurrentActorEditEducationInfoRequest.IsGraduate = EditCurrentActorEducationInfoController.IsGraduate;
    this.CurrentActorEditEducationInfoRequest.CourseType = EditCurrentActorEducationInfoController.CourseType;

    this.CurrentActorEditEducationInfoRequest.Subjects = EditCurrentActorEducationInfoController.Subjects;
    this.CurrentActorEditEducationInfoRequest.Remarks = EditCurrentActorEducationInfoController.Remarks;
   

    this.isNew = false;
    this.isEdit = true;


  }
  RadioAssignChange(value: any) {

    //alert(value);
    var selected: any = value;
    //alert(selected.NurseDisplayName);
    var ind: number = 0;
   
     
      ind++;
    }

  
  onEditSubmit() {

   // alert("On edit Submit");
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 2;
    //console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);
    //console.log('this.CurrentActorEditEducationInfoRequest.CompletedAt...>' + this.CurrentActorEditEducationInfoRequest.CompletedAt);

    //var a = this.converToLocalTime(this.CurrentActorEditEducationInfoRequest.StartFrom);
    //console.log('a----------------------->'+a);
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditEducationInfoRequest.StartFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEducationInfoRequest.StartFrom);
    //  this.CurrentActorEditEducationInfoRequest.CompletedAt = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEducationInfoRequest.CompletedAt);
    //  //this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.CurrentActorEditEducationInfoRequest.StartFrom);

    //  //this.CurrentActorEditEducationInfoRequest.CompletedAt = new Date(this.CurrentActorEditEducationInfoRequest.CompletedAt);


    //  //if (this.CurrentActorEditEducationInfoRequest.StartFrom != null && this.CurrentActorEditEducationInfoRequest.StartFrom.getFullYear() > 1990) {
    //  //  console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);

    //  //  this.CurrentActorEditEducationInfoRequest.StartFrom.setMinutes(this.CurrentActorEditEducationInfoRequest.StartFrom.getMinutes() + -(this.CurrentActorEditEducationInfoRequest.StartFrom.getTimezoneOffset()))

    //  //  console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);


    //  //}
    //  //if (this.CurrentActorEditEducationInfoRequest.CompletedAt != null && this.CurrentActorEditEducationInfoRequest.CompletedAt.getFullYear() > 1990) {

    //  //  this.CurrentActorEditEducationInfoRequest.CompletedAt.setMinutes(this.CurrentActorEditEducationInfoRequest.CompletedAt.getMinutes() + -(this.CurrentActorEditEducationInfoRequest.CompletedAt.getTimezoneOffset()))

    //  //}

    //}



    if (this.ValidFrom != null) {



      this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditEducationInfoRequest.CompletedAt = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEditEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEducationInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  //Editbranch() {

  //  const modalRef = this.modalService.open(NgbEditBranchModal,
  //    {
  //      centered: true,

  //    })

  //}
  //Editconsultant() {
  //  const modalRef = this.modalService.open(NgbEditConsultantModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })
  //  modalRef.componentInstance.ServiceCode = this.ServiceCode;
  //  modalRef.result.then(x => { this.GetConsultantMap()})
  //}


  del_(EducationCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(EducationCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  //AddService() {
  //  const modalRef = this.modalService.open(NgbAddServiceModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  DeleteActorIdentities(EducationCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 3;
    this.CurrentActorEducationInfoRequest.EducationCode = EducationCode;
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetActorEducationInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  //maxDate: NgbDateStruct;
  //minDate: NgbDateStruct;

  AddRequest: MasterH2RContractAddRequest;
  AddNewOperation() {
    this.StartRefreshing();

    var shifts = this.CurrentShiftTypeInfoController.filter(x => x.ShiftTypeCode == this.AddRequest.PreferedShiftTypeCode);
    this.AddRequest.PreferedShiftType = shifts[0].Name; // ShiftDeail 

    var roles = this.CurrentStaffTypeInfoController.filter(x => x.StaffTypeCode == this.AddRequest.StaffTypeCode);
    this.AddRequest.StaffType = roles[0].Name;
    this.AddRequest.Remarks = "Resource Added Directly by Hospital";
    //alert(this.AddRequest.Remarks);


    this.AddRequest.RegistryActorCode = this.SelectedRegistry.FacilityActorCode;
    this.AddRequest.FromDate = new Date();
    this.AddRequest.ToDate = new Date();
    this.AddRequest.R2NPayRate = this.AddRequest.PayRate;



    
    this.hcareservice.SaveMasterH2RContract(this.AddRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetMasterH2RContractController();
            //this.GetActorEducationInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!" + this.ApiResData.ResultDescription);
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }


  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      //const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      //modalRef.componentInstance.ActorDocCode = ActorDocCode;
      //modalRef.componentInstance.CanEdit = this.CanEdit;
      //modalRef.componentInstance.CanShow = this.CanShow;
     
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



   converToLocalTime(serverDate) :Date{
     if (serverDate != null) {
       var dt = new Date(Date.parse(serverDate));
       var localDate = dt;

       var gmt = localDate;
       var min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
       var localNow = new Date().getTimezoneOffset(); // get the timezone
       // offset in minutes
       var localTime = min - localNow; // get the local time

       var dateStr = new Date(localTime * 1000 * 60);
       // dateStr = dateStr.toISOString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"); // this will return as just the server date format i.e., yyyy-MM-dd'T'HH:mm:ss.SSS'Z'
       //dateStr = dateStr.toString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

       console.log('dateStr-------------' + dateStr);
       console.log('dateStr.toISOString-------------' + dateStr.toISOString());
       console.log('dateStr.toISOString to date-------------' + new Date(dateStr.toISOString()));
       return dateStr;
     }
     else {
       return null;
     }
   }
  //AddCategory() {
  //  const modalRef = this.modalService.open(NgbAddCategoryModal,
  //    {
  //      centered: true,
        
  //    })
  //}
  //EditCategory() {
  //  const modalRef = this.modalService.open(NgbEditCategoryModal,
  //    {
  //      centered: true,
      
  //    })
  //}
}
